import logo from "@Assets/Home.svg";
import SectionBox from "@Components/SectionBoxComponent/SectionBox";
import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { GenericHomePageStyles } from "./GenericHomePageStyles";

/**
 * sectionsBox is an array of objects, each representing a section box configuration.
 *
 * Each object in the array should have the following structure:
 *
 * {
 *   textBeside: string             // The label displayed next to the icon (e.g., "Pending Orders")
 *   icon: React.ElementType        // The icon component to display (e.g., AssignmentRoundedIcon)
 *   iconColor: string              // The color of the icon (e.g., yellow[700])
 *   iconFontSize: string | number  // The size of the icon, often based on theme.spacing (e.g., theme.spacing(10))
 *   boxbackgroundColor: string     // The background color of the section box (e.g., yellow[100])
 *   onClick: () => void            // Function to execute when the box is clicked
 * }
 */
const GenericHomePage = ({ sectionsBox }) => {
  const theme = useTheme();
  return (
    <GenericHomePageStyles>
      <Box className="pageContainerStyles">
        <Container
          sx={{ pb: 5, pr: "0px !important", pl: "0px !important" }}
          disableGutters
        >
          <Grid container spacing={4}>
            <Grid item xs={12} className="headerGrid">
              <Paper className="headerPaper">
                <Grid container spacing={0}>
                  <Grid item xs={12} md={6}>
                    <img
                      className="headerImage"
                      src={logo}
                      alt="can't download the image"
                    />
                  </Grid>
                  <Grid item xs={12} md={6} className="headerTxtGrid">
                    <Typography
                      component="p"
                      color={theme.palette.primary.main}
                      fontWeight="bold"
                      marginBottom={1}
                      className="headerTitle1"
                    >
                      C-Gate System
                    </Typography>

                    <Typography
                      variant="body1"
                      color={theme.palette.secondary.main}
                      className="headerSubTitle"
                    >
                      Simplifying Clearance Transitions with Seamless Tracking
                      and Strategic Decision-Making.
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={4}
            justifyContent="center"
            marginTop={theme.spacing(0)}
          >
            {sectionsBox.map((box, index) => (
              <Grid item xs={box.size ? box.size : 4} className="iconsBoxes">
                <SectionBox
                  key={index}
                  textBeside={box.textBeside}
                  icon={box.icon}
                  iconColor={box.iconColor}
                  iconFontSize={box.iconFontSize}
                  boxbackgroundColor={box.boxbackgroundColor}
                  onClick={box.onClick}
                />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </GenericHomePageStyles>
  );
};

export default GenericHomePage;
